import { type InteractionLogEntry } from '../../../types/interaction-log-data';

export const getIndentLevel = (log: InteractionLogEntry): number => {
  if (log.EventType === 'FlowStart' || log.EventType === 'FlowEnd') {
    return 0;
  }
  if (log.EventType === 'Parameters' || log.EventType === 'ExecutionResult') {
    return 1;
  }
  return 0;
};
